import React from "react";
import CustomizerComponent from "@/bit/components/next13.components.customizer-component";
import Card from "@/component/card";

const Banner = ({ bannerProps }) => {
  return (
    <section className="container banner-cards" data-cy="Section heros">
      <div className="banner-cards--content">
        <div className="banner-cards--content_card">
          <CustomizerComponent
            name="CMS-GP-HOME-HERO-1"
            Component={Card}
            componentProps={{...bannerProps[0], setPriority: true}}
            componentName="BannerCardHero1"
            skeletonClassName="skeleton-banner-card"
          />
        </div>
        <div className="banner-cards--content_card">
          <CustomizerComponent
            name="CMS-GP-HOME-HERO-2"
            Component={Card}
            componentProps={{...bannerProps[1], setPriority: true}}
            componentName="BannerCardHero2"
            skeletonClassName="skeleton-banner-card"
          />
        </div>
        <div className="banner-cards--content_card">
          <CustomizerComponent
            name="CMS-GP-HOME-HERO-3"
            Component={Card}
            componentProps={{...bannerProps[2], setPriority: true}}
            componentName="BannerCardHero3"
            skeletonClassName="skeleton-banner-card"
          />
        </div>
      </div>
      <style jsx>
        {`
          .banner-cards {
            padding-top: 0.75rem;
            &--content {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              margin: 0 auto;
              justify-content: space-between;
          
              &_card {
                position: relative;
                display: flex;
                width: 100%;
                min-height: 382px;
              }
              &_card:not(:first-child) {
                max-width: 49%;
                min-height: 269px;
              }
            }
            /* MOBILE L */
            @media screen and (min-width: 480px) {
              &--content {
                &_card {
                  min-height: 550px;
                }
              }
            }
            /* Tablet */
            @media screen and (min-width: 768px) {
              margin: 0 auto;
              padding-top: 1rem;
              padding-bottom: 1rem;
              &--content {
                flex-wrap: nowrap;
                gap: 1rem;
                &_card {
                  min-height: 343px;
                }
              }
            }
            /* LAPTOP */
            @media screen and (min-width: 1024px) {
              &--content {
                &_card {
                  min-height: 447px;
                }
              }
            }

            @media screen and (min-width: 1280px) {
              margin: 0 auto;
              padding-top: 1.5rem;
              padding-bottom: 1.5rem;
              &--content {
                flex-wrap: nowrap;
                gap: 1.5rem;
                &_card {
                  min-height: 508px;
                }
              }
            }
          }
        `}
      </style>
    </section>
  );
};

export default Banner;
